import classNames from 'classnames';
import EcoImg from 'eco-design/base/eco-img';
import React, { useEffect, useState } from 'react';
import { EcoSpecSelectorParamType, EcoSpecSelectorParamGroupType, EcoSpecSelectorItemType, EcoSpecSelectorType } from './type';
import EcoSelector from 'eco-design/base/eco-selector';
import EcoTitle from 'eco-design/base/eco-title';
import './index.scss';
import { EcoSelectorItemType } from 'eco-design/base/eco-selector/typs';
import { i18n as i18nText } from './i18n';
import { useRouter } from 'next/router';

/**
 *  产品Spec选择器
 *  @param name 产品Spec选择器
 *  @param author kalkin
 *  @param date 2025-07-17
 *  @param version 1.0.0
 **/
const EcoSpecSelector: React.FC<EcoSpecSelectorType> = ({ className, theme = 'white', title, selector, items }) => {
    const { locale = '' } = useRouter();
    const i18n = i18nText[locale] || i18nText['en'];
    const prefixCls = `eco-spec-selector`;
    const compCls = classNames(prefixCls, {
        [`${className}`]: className,
        [`${prefixCls}-theme-${theme}`]: theme,
    });
    const HAS_SELECTOR = selector?.items?.length > 1;
    const [activeSelect, setActiveSelect] = useState<EcoSelectorItemType>(selector?.items?.[0]);
    const [activeProduct, setActiveProduct] = useState<EcoSpecSelectorItemType>(items[0]);

    const handleSelectChange = (item: EcoSelectorItemType) => {
        setActiveSelect(item);
        const idx = selector?.items?.findIndex((list: EcoSelectorItemType) => list?.value === item?.value);
        if (idx !== -1) {
            setActiveProduct(items[idx]);
        }
    };

    return (
        <div className={compCls}>
            {title && <EcoTitle className={`${prefixCls}-title`} title={title} />}
            {HAS_SELECTOR && (
                <div className={`${prefixCls}-selector-wrapper`}>
                    <EcoSelector
                        className={`${prefixCls}-selector`}
                        {...selector}
                        theme={theme}
                        placeholder={selector?.placeholder || i18n.placeholder}
                        onChange={handleSelectChange}
                    />
                </div>
            )}
            {activeProduct?.img && <EcoImg className={`${prefixCls}-img`} pc={activeProduct?.img} />}
            {(activeProduct?.title || activeSelect?.label) && (
                <EcoTitle
                    className={`${prefixCls}-product-name${!HAS_SELECTOR ? ` ${prefixCls}-product-name-single` : ''}`}
                    title={activeProduct?.title || activeSelect?.label}
                />
            )}
            {activeProduct && (
                <ul className={`${prefixCls}-groups`}>
                    {activeProduct?.paramGroups?.map((group: EcoSpecSelectorParamGroupType, k: number) => (
                        <li className={`${prefixCls}-group`} key={k}>
                            {group?.title && <EcoTitle className={`${prefixCls}-group-title`} title={group?.title} />}
                            <ul className={`${prefixCls}-group-params`}>
                                {group?.params?.map((param: EcoSpecSelectorParamType, m: number) => (
                                    <li className={`${prefixCls}-param`} key={`${k}_${m}`}>
                                        <p className={`${prefixCls}-param-title`}>{param?.title}</p>
                                        <p className={`${prefixCls}-param-desc`}>{param?.desc}</p>
                                    </li>
                                ))}
                            </ul>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default EcoSpecSelector;
